/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboDeleteintegrationDeleteIntegrationResult
 */
export interface JumboDeleteintegrationDeleteIntegrationResult {
    /**
     * 
     * @type {number}
     * @memberof JumboDeleteintegrationDeleteIntegrationResult
     */
    affected?: number;
}

/**
 * Check if a given object implements the JumboDeleteintegrationDeleteIntegrationResult interface.
 */
export function instanceOfJumboDeleteintegrationDeleteIntegrationResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboDeleteintegrationDeleteIntegrationResultFromJSON(json: any): JumboDeleteintegrationDeleteIntegrationResult {
    return JumboDeleteintegrationDeleteIntegrationResultFromJSONTyped(json, false);
}

export function JumboDeleteintegrationDeleteIntegrationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboDeleteintegrationDeleteIntegrationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'affected': !exists(json, 'affected') ? undefined : json['affected'],
    };
}

export function JumboDeleteintegrationDeleteIntegrationResultToJSON(value?: JumboDeleteintegrationDeleteIntegrationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'affected': value.affected,
    };
}

